import { useState } from "react";
import { Bell, Check, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { trackEvent } from "@/lib/analytics";

const inp = "w-full bg-white border-2 border-[color:var(--vt-dark)] px-3 py-2.5 text-sm focus:outline-none focus:border-[color:var(--vt-amber)]";

export default function NotifyMe({ sports, ages, preset }) {
  const list = [...new Set([...(preset ? [preset.sport] : []), ...(sports || []), "Other"])];
  const [f, setF] = useState({ sport: preset?.sport || list[0], age: preset?.age || "", email: "", newsletter: false });
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!/\S+@\S+\.\S+/.test(f.email)) { setErr("Enter a valid email."); return; }
    setState("busy"); setErr("");
    try {
      await api.post("/starter-kit/notify", { email: f.email, sport: f.sport, age: f.age });
      if (f.newsletter) {
        await api.post("/newsletter", { email: f.email, role: "coach", source: "starter_kit_notify" }).catch(() => {});
        trackEvent("newsletter_signup", { source: "starter_kit_notify" });
      }
      setState("done");
    } catch { setErr("Couldn't save. Please try again."); setState("idle"); }
  };

  if (state === "done") return (
    <div className="border-2 border-dashed border-[color:var(--vt-dark)] p-5 flex gap-3 items-start" data-testid="sk-notify-done">
      <Check className="text-[color:var(--vt-amber)] shrink-0" />
      <p className="text-sm text-[color:var(--vt-body-on-cream)]">You're on the list for <b>{f.sport}</b>. We'll email you the day it opens.</p>
    </div>
  );
  return (
    <form noValidate onSubmit={submit} className="border-2 border-dashed border-[color:var(--vt-dark)] p-5 space-y-3" data-testid="sk-notify-form">
      <p className="font-head uppercase text-sm text-[color:var(--vt-dark)] flex items-center gap-2"><Bell size={16} className="text-[color:var(--vt-amber)]" /> {preset ? `${preset.sport} ${preset.age} is coming soon` : "Your sport isn't here yet?"}</p>
      <p className="text-xs text-[color:var(--vt-body-on-cream)]">{preset ? "It's in final review with Coach Kyto. Get one email the day it opens." : "Get one email when your sport's Starter Kit is ready."}</p>
      <div className="grid grid-cols-2 gap-2">
        <select data-testid="sk-notify-sport" className={inp} value={f.sport} onChange={set("sport")}>{list.map((s) => <option key={s} value={s}>{s}</option>)}</select>
        <select data-testid="sk-notify-age" className={inp} value={f.age} onChange={set("age")}>
          <option value="">Any age</option>{(ages || []).map((a) => <option key={a} value={a}>{`Ages ${a}`}</option>)}
        </select>
      </div>
      <input data-testid="sk-notify-email" type="email" placeholder="you@email.com" className={inp} value={f.email} onChange={set("email")} />
      <label className="flex items-center gap-2 text-xs text-[color:var(--vt-body-on-cream)]">
        <input data-testid="sk-notify-newsletter" type="checkbox" checked={f.newsletter} onChange={set("newsletter")} className="accent-[color:var(--vt-amber)]" />
        Also send me the weekly Voluntold coaching newsletter
      </label>
      {err && <p className="text-xs text-[#B3261E]" data-testid="sk-notify-error">{err}</p>}
      <button data-testid="sk-notify-submit" disabled={state === "busy"} className="flex items-center gap-2 px-4 py-2 border-2 border-[color:var(--vt-dark)] font-head uppercase text-xs hover:bg-[color:var(--vt-dark)] hover:text-[color:var(--vt-cream)] transition-colors disabled:opacity-50">
        {state === "busy" && <Loader2 size={14} className="animate-spin" />} Notify me
      </button>
    </form>
  );
}
